import { Subject, Observable, Subscription } from 'rxjs';
import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy
} from '@angular/core';
import { AuthenticationService } from './../core/services/authentication.service';
import * as _ from 'lodash';
import { FieldType } from '../core/models/fieldType.enum';
import { TranslateService } from '@ngx-translate/core';
import { BzgModalService, BzgToastService, BzgToastType } from 'bz-genome-angular';
import { I18nService } from 'i18n/i18n.service';
import { PendingChangesAuthenticationAlertComponent } from './modal-actions/security-authentication-pendingchanges.component';
import { OptionDataType } from '../core/typings/AutheticationOptionsDataTypes';
import { Router } from '@angular/router';
import { CryptoDataService } from '../../core/services/crypto.data.service';
import { Store, select } from '@ngrx/store';
import {
  SetMultipleViewMode,
  GetMetadata,
  GetMaintenanceWindowStatus,
  GetAuthenticationData,
  SetCurrentAuthenticator,
  GetMultipleOptions,
  SaveAuthenticationData,
  AddNewMultipleAuthenticator,
  UpdateAuthenticatorOption,
  UpdateMultipleAuthenticator,
  DeleteAuthenticators,
  CleanMultipleAuthState,
  UpdateDomainList,
  GetMultipleOptionsDefaultValues,
  GetAuthenticationIsValid
} from './store/actions/authentication.actions';
import {
  multipleViewMode,
  isAvailableToEdit,
  getMetadata,
  getAuthenticationData,
  multipleMethods,
  currentAuthenticator,
  multipleOptions,
  currentAuthenticatorOptionsMetadata,
  multipleOptionsDefaultValues,
  isValid
} from './store/selectors/authentication.selectors';
import { EMultipleAuthViewMode } from './core/security-authentication.enum';
import { PendingChangesMultiAuthService } from './core/pending-changes.service';
import { MultipleAuthDetailComponent } from './multiple-auth-detail/multiple-auth-detail.component';
import { SecurityAuthDetailComponent } from './security-auth-detail/security-auth-detail.component';
import { IAppState } from 'app/IAppState';
import { IAuthenticationMethod, IBasicAuthenticationMethod, IMixedAuthenticationMethod, IOAuth2AuthenticationMethod, IOAuthOptionsFlow, IOAuthOptionsFlowProperty } from '../core/typings/IAuthentication';
import { DomainAuthenticator, MultipleAuthenticator } from './core/authentication-contracts';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Component({
  selector: 'security-authentication',
  templateUrl: 'security-authentication.component.html',
  styleUrls: ['security-authentication.component.scss']
})
export class SecurityAuthenticationComponent implements OnInit, OnDestroy {
  @ViewChild('file', { static: false }) file;
  @ViewChild('bzMultipleAuthDetail', { static: false })
  _bzMultipleAuthDetail: MultipleAuthDetailComponent;
  @ViewChild('bzSecurityAuthDetail', { static: false })
  _bzSecurityAuthDetail: SecurityAuthDetailComponent;
  /* @ViewChild("bzSecurityAuthDetail") _bzSecurityAuthDetail: SecurityAuthDetailComponent; */

  public _template: { [key: string]: any } = {};
  public optionDataType: OptionDataType;
  public dataDropDown: any[] = [];
  public metadata: any;
  public metadata$: Observable<any>;
  public multipleOptions$: Observable<Array<any>>;
  public multipleOptionsDefaultValues$: any;
  public currentAuthenticatorOptionsMetadata$: Observable<any>;
  public authenticatorList$: Observable<any>;
  public currentAuthenticator$: Observable<MultipleAuthenticator>;
  public isEditable = false;
  public isEditable$: Observable<boolean>;
  public authenticationData$: Observable<any>;
  public currentAllowedExtensions: string;
  public showOptionDetail: boolean;
  public initialAuthenticationType: string;
  public isValidAuthentication = false;
  public showErrorHeader = false;
  public isSaving = false;
  public typeInvalid = '';
  public subtypeInvalid = '';
  public isValidAuthentication$: Observable<boolean>;

  public isValidAuthenticationSubscription: Subscription;
  public metadataSubscription: Subscription;
  public isEditableSubscription: Subscription;
  public authenticationDataSubscription: Subscription;
  public authenticatorOptionsMetadataSubscription: Subscription;
  public currentAuthenticatorSubscription: Subscription;
  public multipleViewModeSubscription: Subscription;

  public selectedMethod: IAuthenticationMethod;

  private _catalogObjectResponse: any;
  private _authenticationContent: any;
  private activeFlow: string;
  private _optionsListsContainer: Array<IAuthenticationOptionsList> = [];
  private _currentAuthenticatorOptionsMetadata: any;
  private _currentAuthenticator: MultipleAuthenticator;
  private _multipleViewMode: number;

  private selectedMixedMethod: IAuthenticationMethod;
  private selectedFlow: IOAuthOptionsFlow;
  private selectedMetadata: { [key: string]: any };
  public selectedOption:
    | { key: string; value: string }
    | IOAuthOptionsFlowProperty;
  private currentValue: string;
  private currentFileName: string;
  private keyOption: string;
  public descriptionOption: string;
  private booleanDetailValue: boolean = undefined;
  private numericDetailValue: any = undefined;
  private initialBooleanDetailValue: boolean = undefined;
  private initialNumericDetailValue: any = undefined;
  private currentNumeric: any = undefined;
  private stringDetailValue: string = undefined;
  private initialStringDetailValue: string = undefined;
  private stringDetailValueDrop: any;
  public loadingAuthentication: boolean;
  public readonly authMethodsVpnRequired = ['Ldap', 'Windows'];
  public readonly authMethodsOtherVpnRequired = ['Ldap', 'Windows'];

  public multipleViewMode$: Observable<number>;

  saveResponse$: Subject<boolean> = new Subject<boolean>();
  changeDialogResponse$ = new Subject<boolean>();

  constructor(
    private _store: Store<IAppState>,
    private _authenticationService: AuthenticationService,
    private _translateService: TranslateService,
    private _toastService: BzgToastService,
    private _i18nService: I18nService,
    private _router: Router,
    private _cryptoDataService: CryptoDataService,
    private _modalService: BzgModalService,
    private _pendingChangesService: PendingChangesMultiAuthService,
    private _showToastService: ShowToastService
  ) {
    this.multipleViewMode$ = this._store.pipe(select(multipleViewMode));
    this.metadata$ = this._store.pipe(select(getMetadata));
    this.isEditable$ = this._store.pipe(select(isAvailableToEdit));
    this.isValidAuthentication$ = this._store.pipe(select(isValid));
    this.authenticationData$ = this._store.pipe(select(getAuthenticationData));
    this.authenticatorList$ = this._store.pipe(select(multipleMethods));
    this.currentAuthenticator$ = this._store.pipe(select(currentAuthenticator));
    this.multipleOptions$ = this._store.pipe(select(multipleOptions));
    this.multipleOptionsDefaultValues$ = this._store.pipe(
      select(multipleOptionsDefaultValues)
    );
    this.currentAuthenticatorOptionsMetadata$ = this._store.pipe(
      select(currentAuthenticatorOptionsMetadata)
    );
  }

  async ngOnInit() {
    this._initializeState();
  }

  ngOnDestroy(): void {
    if (this.authenticatorOptionsMetadataSubscription) {
      this.authenticatorOptionsMetadataSubscription.unsubscribe();
    }
    if (this.currentAuthenticatorSubscription) {
      this.currentAuthenticatorSubscription.unsubscribe();
    }
    if (this.multipleViewModeSubscription) {
      this.multipleViewModeSubscription.unsubscribe();
    }
    if (this.isValidAuthenticationSubscription) {
      this.isValidAuthenticationSubscription.unsubscribe();
    }

    this._store.dispatch(new CleanMultipleAuthState());
  }

  private async _initializeState() {
    this._store.dispatch(new GetMetadata());
    this._store.dispatch(new GetMaintenanceWindowStatus());
    this._store.dispatch(new GetAuthenticationData());
    this._store.dispatch(new GetMultipleOptions());
    this._store.dispatch(new GetMultipleOptionsDefaultValues());
    this._store.dispatch(new GetAuthenticationIsValid());

    this.authenticatorOptionsMetadataSubscription = this.currentAuthenticatorOptionsMetadata$.subscribe(
      value => (this._currentAuthenticatorOptionsMetadata = value)
    );
    this.currentAuthenticatorSubscription = this.currentAuthenticator$.subscribe(
      value => (this._currentAuthenticator = value)
    );
    this.multipleViewModeSubscription = this.multipleViewMode$.subscribe(
      value => (this._multipleViewMode = value)
    );

    this.metadataSubscription = this.metadata$.subscribe(metadata => {
      this.metadata = metadata;
      this.loadingAuthentication = true;
      this.authenticationDataSubscription = this.authenticationData$.subscribe(
        response => {
          if (!!response) {
            this._catalogObjectResponse = response;
            const content = response[0].content;
            this._authenticationContent = content;
            this._loadActiveMethod();
            this.loadingAuthentication = false;
          }
        },
        error => {
          this.loadingAuthentication = false;
        }
      );
    });
    this.isEditableSubscription = this.isEditable$.subscribe(
      (isEditable: boolean) => {
        this.isEditable = isEditable;
      }
    );
    this.isValidAuthenticationSubscription = this.isValidAuthentication$.subscribe(
      (isValidAuthentication: boolean) => {
        this.isValidAuthentication = isValidAuthentication;
      }
    );
    this._authenticationService
      .getTemplateAuthentication()
      .subscribe(response => {
        this._template = response;
      });
  }

  public onTypeOrSubtypeChange(type: string, subtype: string, isType: boolean) {
    if (!isType && !subtype)
      subtype = (this.selectedMethod as IBasicAuthenticationMethod).subtype;
    if (isType && this.selectedMethod && this.selectedMethod.type === type) {
      subtype = (this.selectedMethod as IBasicAuthenticationMethod).subtype;
    }
    this.showErrorHeader = true;
    this.currentValue = null;
    this.selectedOption = null;
    this.setCurrentMethod(type, subtype);
  }

  public onFlowChange(method: IOAuth2AuthenticationMethod, event: string) {
    this.selectedOption = null;
    this.currentValue = null;
    this.setCurrentFlow(event);
  }

  private _loadActiveMethod() {
    if (this._authenticationContent.active) {
      this.initialAuthenticationType = this._authenticationContent.active;
      if (this._authenticationContent.activeSubtype) {
        this.setCurrentMethod(
          this._authenticationContent.active,
          this._authenticationContent.activeSubtype
        );
      } else {
        this.setCurrentMethod(this._authenticationContent.active);
      }
    }
  }

  public setCurrentMethod(type: string, subtype?: string) {
    this.selectedFlow = undefined;
    if (subtype) {
      this.selectedMethod = _.find(this._authenticationContent.methods, {
        type,
        subtype
      }) as IBasicAuthenticationMethod;
      const updatedAuthenticationContent = { ...this._authenticationContent, active: type, activeSubtype: subtype };
      this._authenticationContent = updatedAuthenticationContent;
      if (this.metadata[type])
        this.selectedMetadata = this.metadata[type].options[subtype];
      else {
        this.typeInvalid = type;
        this.subtypeInvalid = subtype;
      }

    } else {
      this.selectedMethod = _.find(this._authenticationContent.methods, {
        type
      });
      if (this.selectedMethod) {
        if (this.metadata[type]) {
          this.selectedMetadata = (this
            .selectedMethod as IBasicAuthenticationMethod).subtype
            ? this.metadata[type].options[
            (this.selectedMethod as IBasicAuthenticationMethod).subtype
            ]
            : this.metadata[type].options;
        }
        const updatedAuthenticationContent = { ...this._authenticationContent, active: type, activeSubtype: subtype };
        if (!('activeSubtype' in updatedAuthenticationContent)) {
          updatedAuthenticationContent.activeSubtype = (this.selectedMethod as IBasicAuthenticationMethod).subtype || '';
        }
        this._authenticationContent = updatedAuthenticationContent;
      } else
        this.typeInvalid = type;
    }

    if (this.selectedMethod) {
      if ((this.selectedMethod as IOAuth2AuthenticationMethod).oauthOptions) {
        this.setCurrentFlow(
          (this.selectedMethod as IOAuth2AuthenticationMethod).oauthOptions
            .activeFlow
        );
      }
      if (this.selectedMethod.type === 'Mixed') {
        const selectedMethod = {
          ...this.selectedMethod,
          options: JSON.parse(JSON.stringify((this.selectedMethod as IMixedAuthenticationMethod).options))
        };
        selectedMethod.options.otherAuthenticationType = selectedMethod.options.otherAuthenticationType || 'Custom';
        this.selectedMethod = selectedMethod;
        this.selectMixedOption('Bizagi');
      }
      this._authenticationContent = { ...this._authenticationContent, active: type, activeSubtype: subtype };
    }
  }

  public selectMixedOption(type: string) {
    this.selectedMixedMethod = _.find(this._authenticationContent.methods, {
      type
    });
    this.selectedMetadata = this.metadata[type].options;
  }
  public setCurrentFlow(flow: string) {
    this.selectedFlow = _.find(
      (this.selectedMethod as IOAuth2AuthenticationMethod).oauthOptions.flows,
      { name: flow }
    );

    const updatedMethod = {
      ...this.selectedMethod,
      oauthOptions: {
        ...(this.selectedMethod as IOAuth2AuthenticationMethod).oauthOptions,
        activeFlow: flow
      }
    } as IOAuth2AuthenticationMethod;
    
    this.selectedMethod = updatedMethod;

    this.selectedMetadata = this.metadata[this.selectedMethod.type].options[
      (this.selectedMethod as IOAuth2AuthenticationMethod).subtype
    ][flow];
  }

  public updateDomainList(domainList: DomainAuthenticator[]) {
    this._store.dispatch(new UpdateDomainList(domainList));
  }

  private _getExtensions(extensions: Array<string>) {
    let extensionsString = '*';

    if (extensions) {
      const mappedExtensions = extensions.map(extension => {
        return '.' + extension;
      });
      extensionsString = mappedExtensions.join();
    }

    return extensionsString;
  }

  public navigateWindowMaintenance() {
    this._router.navigate(['mc', 'Maintenance']);
  }

  setNewAuthenticator(newAuthenticator: MultipleAuthenticator) {
    this._store.dispatch(new AddNewMultipleAuthenticator(newAuthenticator));
    this._store.dispatch(new SaveAuthenticationData());
    this.setMultipleViewMode(EMultipleAuthViewMode.Edit, newAuthenticator);
  }

  updateAuthenticator(editedAuthenticator: MultipleAuthenticator) {
    if (editedAuthenticator) {
      this._bzMultipleAuthDetail.updateAuthenticatorOptions();
      this._store.dispatch(
        new UpdateMultipleAuthenticator(editedAuthenticator)
      );
      this._store.dispatch(new SetCurrentAuthenticator(editedAuthenticator));
    }

    this._store.dispatch(new SaveAuthenticationData());
  }

  SaveAll() {
    const commonOption = this.selectedOption as { key: string; value: string };
    const oauthOption = this.selectedOption as IOAuthOptionsFlowProperty;
    let fileNameProperty = null;

    const currentFileName = this._bzSecurityAuthDetail
      ? this._bzSecurityAuthDetail.currentFileName
      : null;
    const currentValue = this._bzSecurityAuthDetail
      ? this._bzSecurityAuthDetail.currentValue
      : null;
    if (this.selectedMethod.type === 'Multiple') {
      this.saveData();
    } else {
      fileNameProperty =
        this.selectedOption && this.selectedMetadata[commonOption.key]
          ? this.selectedMetadata[commonOption.key].name
          : null;

      if (this.selectedOption && this.selectedMetadata){
        this.updateData(
          this.selectedOption,
          currentValue,
          !!oauthOption.name,
          fileNameProperty,
          currentFileName
        );
      }
      else {
        if (this.selectedMethod.type === 'OAuth2') {
          this.updateActiveFlowOauth2();
        }
        this.confirmUpdate();
      }
    }
  }

  private updateActiveFlowOauth2() {
    let methodActiveFlow = (this.selectedMethod as IOAuth2AuthenticationMethod).oauthOptions.activeFlow;

    const updatedAuthenticationContent = {
      ...this._authenticationContent,
      activeFlow: methodActiveFlow
    };

    const updatedMethods = updatedAuthenticationContent.methods.map(method => {
      if (method.type === this.selectedMethod.type &&
        method.subtype === (this.selectedMethod as IOAuth2AuthenticationMethod).subtype) {
        return {
          ...method,
          oauthOptions: {
            ...method.oauthOptions,
            activeFlow: methodActiveFlow
          }
        };
      }
      return method;
    });

    this._authenticationContent = {
      ...updatedAuthenticationContent,
      methods: updatedMethods
    };
  }

  setMultipleViewMode(
    mode: EMultipleAuthViewMode,
    selectedAuthenticator?: MultipleAuthenticator
  ) {
    this.showOptionDetail = false;
    if (this._bzSecurityAuthDetail) {
      this._pendingChangesService.initialize(
        this._store,
        this._bzSecurityAuthDetail
      );
      this._pendingChangesService.selectedAuthenticator = selectedAuthenticator;
      this._pendingChangesService.check(mode, 'security');
    } else if (
      !!this._pendingChangesService.selectedAuthenticator &&
      this._multipleViewMode !== EMultipleAuthViewMode.Add
    ) {
      this._pendingChangesService.initialize(
        this._store,
        this._bzMultipleAuthDetail || this._bzSecurityAuthDetail
      );
      this._pendingChangesService.selectedAuthenticator = selectedAuthenticator;
      this._pendingChangesService.check(mode);
    } else {
      switch (mode) {
        case EMultipleAuthViewMode.Add:
          this._store.dispatch(new SetMultipleViewMode(mode));
          const newAuthenticator: MultipleAuthenticator = {
            type: '',
            subtype: '',
            displayName: '',
            enabled: true,
            domains: [],
            options: {},
            oauthOptions: {}
          };
          this._store.dispatch(new SetCurrentAuthenticator(newAuthenticator));
          break;
        case EMultipleAuthViewMode.Edit:
          this._pendingChangesService.selectedAuthenticator = selectedAuthenticator;
          this._store.dispatch(new SetMultipleViewMode(mode));
          this._store.dispatch(
            new SetCurrentAuthenticator(selectedAuthenticator)
          );
          break;
        case EMultipleAuthViewMode.Unselect:
          this._store.dispatch(new SetMultipleViewMode(mode));
          this._store.dispatch(new SetCurrentAuthenticator(null));
          break;
      }
    }
  }

  onCancelMultipleDetail() {
    this.setMultipleViewMode(EMultipleAuthViewMode.Unselect);
  }

  private _getOptions() {
    this._optionsListsContainer = [];
    this._clearValuesDetail();
    if (this.selectedMethod.type === 'OAuth2') {
      this.loadOAuthOptions(this.selectedMethod as IOAuth2AuthenticationMethod);
    } else if (this.selectedMethod.type === 'Mixed') {
      this.loadMixedOptions(this.selectedMethod as IMixedAuthenticationMethod);
    } else {
      this.loadOptions(this.selectedMethod as IBasicAuthenticationMethod);
    }
  }

  private loadMixedOptions(selectedMethod: IMixedAuthenticationMethod) {
    this._optionsListsContainer = [];
    this.activeFlow = undefined;

    for (const item in selectedMethod.importMethods) {
      const authType: any = _.find(this._authenticationContent.methods, {
        type: selectedMethod.importMethods[item]
      });
      const optionsList: IAuthenticationOptionsList = {
        displayName: 'AUTHENTICATION.TYPE_' + authType.type,
        options: [],
        active: false
      };

      if (authType) {
        for (const key in authType.options) {
          if (authType.options.hasOwnProperty(key)) {
            this._translateService
              .get(`AUTHENTICATION.OPTIONS_${key}`)
              .subscribe((res: string) => {
                const value = authType.options[key];
                const _option: IAuthenticationOption = {
                  id: value,
                  value: res,
                  type: key,
                  subtype: authType.type,
                  isSelected: false
                };

                optionsList.options.push(_option);
              });
          }
        }
        optionsList.options = _.orderBy(
          optionsList.options,
          ['value'],
          ['asc']
        );
      }

      this._optionsListsContainer.push(optionsList);
    }
    this.selectMixedOption('Bizagi');
    // this._optionsListsContainer[0].active = true;
  }

  private loadOAuthOptions(selectedMethod: IOAuth2AuthenticationMethod) {
    this.activeFlow = selectedMethod.oauthOptions.activeFlow;
    const optionsList: IAuthenticationOptionsList = {
      displayName: 'AUTHENTICATION.TYPE_' + selectedMethod.type,
      options: [],
      active: false
    };
    const selectMethodOptions: Array<IOAuthOptionsFlowProperty> =
      selectedMethod.oauthOptions.flows[0].properties;

    _.forEach(selectMethodOptions, option => {
      this._translateService
        .get(`AUTHENTICATION.OPTIONS_${option.name}`)
        .subscribe((res: string) => {
          const authOption: IAuthenticationOption = {
            id: option.value,
            value: res,
            type: option.name,
            subtype: option.passwordMode,
            isSelected: false
          };
          optionsList.options.push(authOption);
        });
    });

    optionsList.options = _.orderBy(optionsList.options, ['value'], ['asc']);
    this._optionsListsContainer.push(optionsList);
    this._optionsListsContainer[0].active = true;
  }

  private loadOptions(selectedMethod: IBasicAuthenticationMethod) {
    const optionsList: IAuthenticationOptionsList = {
      displayName: 'AUTHENTICATION.TYPE_' + selectedMethod.type,
      options: [],
      active: false
    };

    for (const key in selectedMethod.options) {
      if (selectedMethod.options.hasOwnProperty(key)) {
        this._translateService
          .get(`AUTHENTICATION.OPTIONS_${key}`)
          .subscribe((res: string) => {
            const value = selectedMethod.options[key];
            const _treeItem: IAuthenticationOption = {
              id: value,
              value: res,
              type: key,
              subtype: '',
              isSelected: false
            };
            optionsList.options.push(_treeItem);
          });
      }
    }
    optionsList.options = _.orderBy(optionsList.options, ['value'], ['asc']);
    this._optionsListsContainer.push(optionsList);
    this._optionsListsContainer[0].active = true;
  }
  private _clearValuesDetail() {
    this.booleanDetailValue = undefined;
    this.numericDetailValue = undefined;
    this.currentNumeric = 0;
    this.stringDetailValue = undefined;
    this.keyOption = '';
  }

  private _showPendingChangesDialog(
    saveAction: Function,
    cancelAction: Function
  ) {
    const modal = this._modalService.open(
      PendingChangesAuthenticationAlertComponent,
      { closeOnBackdropClick: false, closeOnRouterNavigation: true }
    );
    modal.afterClosed().subscribe((result: string) => {
      if (result === 'save') {
        saveAction();
      } else {
        cancelAction();
      }
    });
  }

  private UpdateDropDownValues(e: any) {
    this.dataDropDown = [];
    switch (e.type) {
      case 'cookieType':
        this.optionDataType = OptionDataType.Select;
        this.dataDropDown.push(
          { key: '1', value: 'Persistent' },
          { key: '2', value: 'Session' }
        );
        this.stringDetailValueDrop = _.find(
          this.dataDropDown,
          element => element.key === this.numericDetailValue
        );
        break;
      case 'bindingSLO':
      case 'bindingSSO':
        this.optionDataType = OptionDataType.Select;
        this.dataDropDown.push(
          { key: '1', value: 'REDIRECT' },
          { key: '2', value: 'POST' }
        );
        this.stringDetailValueDrop = _.find(
          this.dataDropDown,
          element => element.key === this.numericDetailValue
        );
        break;
      case 'selectedSigningAlgorithm':
        this.optionDataType = OptionDataType.Select;
        this.dataDropDown.push(
          { key: '1', value: 'SHA1' },
          { key: '2', value: 'SHA256' }
        );
        this.stringDetailValueDrop = _.find(
          this.dataDropDown,
          element => element.key === this.numericDetailValue
        );
        break;
      case 'certificateValidationMode':
        this.optionDataType = OptionDataType.Select;
        this.dataDropDown.push(
          { key: 'ChainTrust', value: 'ChainTrust' },
          { key: 'Custom', value: 'Custom' },
          { key: 'None', value: 'None' },
          { key: 'PeerOrChainTrust', value: 'PeerOrChainTrust' },
          { key: 'PeerTrust', value: 'PeerTrust' }
        );
        this.stringDetailValueDrop = _.find(
          this.dataDropDown,
          element => element.key === this.stringDetailValue
        );
        break;
      default:
        break;
    }
  }

  // private resetValues() {
  //   let valueType: number = this.getValueType(this.infoEvent.id);
  //   let value = this.infoEvent.id;
  //   let type = this.infoEvent.type;
  //   switch (valueType) {
  //     case FieldType.boolean: {
  //       this.infoEvent.id = this.initialBooleanDetailValue;
  //       break;
  //     }
  //     case FieldType.number: {
  //       this.infoEvent.id = this.initialNumericDetailValue;
  //       break;
  //     }
  //     case FieldType.string: {
  //       this.infoEvent.id = this.initialStringDetailValue;
  //       break;
  //     }
  //   }
  // };

  private updateInitialValues(value, type): void {
    const valueType: number = this.getValueType(value);
    switch (valueType) {
      case FieldType.boolean: {
        this.updateInitialBooleanValue(value);
        this.optionDataType = OptionDataType.Boolean;
        break;
      }
      case FieldType.number: {
        this.updateInitialNumberValue(value);
        this.optionDataType = OptionDataType.Number;
        break;
      }
      case FieldType.string: {
        this.updateInitialStringValue(value, type);
        this.optionDataType = OptionDataType.String;
        break;
      }
    }
  }

  private updateInitialBooleanValue(value): void {
    this.booleanDetailValue = this.getBooleanValue(value);
    this.initialBooleanDetailValue = this.booleanDetailValue;
  }

  private updateInitialNumberValue(value): void {
    this.numericDetailValue = value;
    this.currentNumeric = this.numericDetailValue;
    this.initialNumericDetailValue = this.numericDetailValue;
  }

  private updateInitialStringValue(value, type): void {
    if (value === '') {
      const dataTemplate: any = _.find(
        this._template,
        t => t.type === this.selectedMethod.type
      );

      if (dataTemplate) {
        const itemTemplate: any = _.find(dataTemplate.templates, { key: type });
        this.stringDetailValue = itemTemplate ? itemTemplate.value : value;
      }
    } else {
      this.setDataString(value);
    }
  }

  private getValueType(value): number {
    if (this.isBooleanValue(value)) {
      return FieldType.boolean;
    } else if (this.isNumberValue(value)) {
      return FieldType.number;
    } else {
      return FieldType.string;
    }
  }

  private isBooleanValue(value): boolean {
    if (typeof value === 'boolean') {
      return true;
    }
    if (typeof value === 'number') {
      return false;
    }
    return value.toLowerCase() === 'true' || value.toLowerCase() === 'false';
  }

  private getBooleanValue(value): boolean {
    if (typeof value === 'string') {
      return value.toLowerCase() === 'true';
    }
    return value;
  }

  private isNumberValue(value): boolean {
    try {
      const numberValue = parseInt(value, 10);
      if (!isNaN(numberValue)) {
        return true;
      } else {
        return false;
      }
    } catch (e) {
      return false;
    }
  }

  private setDataString(stringValue) {

    switch (this.keyOption) {
      case 'bindingSSO':
      case 'bindingSLO':
      case 'certificateValidationMode':
      case 'otherAuthenticationType':
        this.stringDetailValueDrop = _.find(this.dataDropDown, {
          key: stringValue
        });
        break;
    }

    this.stringDetailValue = stringValue;
  }

  private loadMixed() {
    this.dataDropDown = [];
    this.dataDropDown.push({ key: 'Windows', value: 'Windows' });
  }

  public changeOtherAuthentication(value: any) {
    const updatedImportMethods = [...this.selectedMethod.importMethods];
    updatedImportMethods[1] = value;
    this.selectedMethod = {
      ...this.selectedMethod,
      importMethods: updatedImportMethods
    };
    (this.selectedMethod as IMixedAuthenticationMethod).options.otherAuthenticationType = value;
    this.loadMixedOptions(this.selectedMethod as IMixedAuthenticationMethod);
  }

  public changeNumber(value: any) {
    if (value === '') {
      this.numericDetailValue = 0;
      this.currentNumeric = 0;
    } else {
      this.numericDetailValue = value;
      this.currentNumeric = value;
    }
  }

  public confirmUpdate() {
    this.saveData();
  }

  public selectMultipleOption(item) {
    this.showOptionDetail = true;
    if (
      this.selectedOption &&
      this._bzSecurityAuthDetail &&
      this.selectedOption.value !== this._bzSecurityAuthDetail.currentValue
    ) {
      this._pendingChangesService.initialize(
        this._store,
        this._bzSecurityAuthDetail
      );
      this._pendingChangesService.checkOption(
        this._bzSecurityAuthDetail,
        () => {
          this._setMultipleSelectedOption(item, item.key);
          if (this._bzSecurityAuthDetail) {
            this._bzSecurityAuthDetail.currentValue = this.currentValue;
          }
          if (item !== this.selectedOption) {
            this._setMultipleSelectedOption(item, item.key);
          }
        }
      );
    } else {
      if (this._bzSecurityAuthDetail) {
        this._bzSecurityAuthDetail.currentValue = this.currentValue;
      }
      if (item !== this.selectedOption) {
        this._setMultipleSelectedOption(item, item.key);
      }
    }
  }

  public deleteAuthenticators($event) {
    this._store.dispatch(new DeleteAuthenticators($event));
    this._store.dispatch(new SaveAuthenticationData());
  }

  public selectMultipleOAuthOption(item: IOAuthOptionsFlowProperty) {
    this.showOptionDetail = true;
    if (item !== this.selectedOption) {
      this._setMultipleSelectedOption(item, item.name);
    }
  }

  private _setMultipleSelectedOption(
    item: { key: string; value: string } | IOAuthOptionsFlowProperty,
    key: string
  ) {
    if (
      !_.isEmpty(this._currentAuthenticatorOptionsMetadata) &&
      (this._currentAuthenticatorOptionsMetadata[key] as any).type === 'file' &&
      (this._currentAuthenticatorOptionsMetadata[key] as any).name
    ) {
      this.currentFileName = null;
      setTimeout(() => {
        this.currentFileName = (this
          ._currentAuthenticator as IBasicAuthenticationMethod).options[
          (this._currentAuthenticatorOptionsMetadata[key] as any).name
        ];
        this.currentAllowedExtensions = this._getExtensions(
          (this._currentAuthenticatorOptionsMetadata[key] as any).extensions
        );
      }, 100);

    }
    this.selectedOption = item;
    this.currentValue = this.selectedOption.value;
  }

  public selectOption(item) {
    this.showOptionDetail = true;

    if (item !== this.selectedOption) {
      if (
        this.selectedOption &&
        this.selectedOption.value !== this._bzSecurityAuthDetail.currentValue
      ) {
        this._showPendingChangesDialog(
          async () => {
            this.updateData(
              this.selectedOption,
              this._bzSecurityAuthDetail.currentValue
            );
            this._setSelectedOption(item, item.key);
          },
          () => {
            this._setSelectedOption(item, item.key);
          }
        );
      } else {
        this._setSelectedOption(item, item.key);
      }
    }
  }

  public selectOAuthOption(item: IOAuthOptionsFlowProperty) {
    if (item !== this.selectedOption) {
      if (this._bzSecurityAuthDetail.hasChanges) {
        this._showPendingChangesDialog(
          async () => {
            await this.updateData(
              this.selectedOption,
              this._bzSecurityAuthDetail.currentValue,
              true
            );
            this._setSelectedOption(item, item.name);
          },
          () => {
            this._setSelectedOption(item, item.name);
          }
        );
      } else {
        this._setSelectedOption(item, item.name);
      }
    }
  }

  private _setSelectedOption(
    item: { key: string; value: string } | IOAuthOptionsFlowProperty,
    key: string
  ) {
    if (
      item.value === '' &&
      this._template[this.selectedMethod.type] &&
      this._template[this.selectedMethod.type][key]
    ) {
      item.value = this._template[this.selectedMethod.type][key];
    }
    if (
      (this.selectedMetadata[key] as any).type === 'file' &&
      (this.selectedMetadata[key] as any).name
    ) {
      this.currentFileName = null;
      setTimeout(() => {
        this.currentFileName = (this
          .selectedMethod as IBasicAuthenticationMethod).options[
          (this.selectedMetadata[key] as any).name
        ];
        this.currentAllowedExtensions = this._getExtensions(
          (this.selectedMetadata[key] as any).extensions
        );
      }, 100);
    }
    this.selectedOption = item;
    this._bzSecurityAuthDetail.currentValue = this.selectedOption.value;
    this.currentValue = this.selectedOption.value;
  }

  public async updateMultipleData() {
    const option = this._bzSecurityAuthDetail.selectedOption;
    await this._bzSecurityAuthDetail.checkForPasswordOptionAdEncrypt();

    if (
      this._bzSecurityAuthDetail.fileNameProperty &&
      this._bzSecurityAuthDetail.currentFileName
    ) {
      this._store.dispatch(
        new UpdateAuthenticatorOption({
          key: this._bzSecurityAuthDetail.fileNameProperty,
          value: this._bzSecurityAuthDetail.currentFileName
        })
      );
    }

    option.value = this._bzSecurityAuthDetail.currentValue;
    (this._bzSecurityAuthDetail.selectedOption as any) = option;
    this._store.dispatch(new UpdateAuthenticatorOption(option));
    this._store.dispatch(new SaveAuthenticationData());
  }

  public async updateData(
    option: { [key: string]: string } | IOAuthOptionsFlowProperty,
    currentValue: string,
    isOauth = false,
    fileName?: string,
    currentFileName?: string,
    isPasswordForMultiple = false
  ) {
    const metadata =
      Object.keys(this.selectedMetadata).length === 0 &&
      this.selectedMetadata.constructor === Object
        ? this._currentAuthenticatorOptionsMetadata
        : this.selectedMetadata;
    const optionKey = (option as any).key || (option as IOAuthOptionsFlowProperty).name;
    const isPasswordType = metadata?.[optionKey]?.type === 'password';

    if (
      isPasswordForMultiple ||
      (this.selectedMethod.type !== 'Multiple' && isPasswordType)
    ) {
      currentValue = await this._cryptoDataService.encryptStringPromise(currentValue);
      this.currentValue = currentValue;
      if (this._bzSecurityAuthDetail) {
        this._bzSecurityAuthDetail.currentValue = currentValue;
        this._bzSecurityAuthDetail['_currentValueClone'] = currentValue;
      }
    }

    await this._bzSecurityAuthDetail.checkForPasswordOptionAdEncrypt();
    const currentSelectedOption = this.selectedOption;
    const currentShowOptionDetail = this.showOptionDetail;
    this.ManageOption(isOauth, option, currentValue, fileName, currentFileName);
    this.selectedOption = currentSelectedOption;
    this.showOptionDetail = currentShowOptionDetail;
  }

  private ManageOption(
    isOauth: boolean,
    option: IOAuthOptionsFlowProperty | { [key: string]: string },
    currentValue: string,
    fileName: string,
    currentFileName: string
  ) {
    if (this.selectedMethod.type === 'Multiple') {
      this.SetValueMultiple(option, currentValue, currentFileName);
    } else {
      if (!isOauth) {
        if (this.selectedMethod.type === 'Mixed') {
          this.SetValueMixed(option, currentValue);
        } else {
          this.SetValue(option, currentValue, currentFileName);
        }
      }

      if (fileName && currentFileName) {
        if (this.selectedMethod.type === 'Mixed') {
          this.SetValueMixed(fileName, currentFileName);
        } else {
          this.SetValue(fileName, currentFileName);
        }
      }

      if (this.selectedMethod.type === 'OAuth2') {
        this.SetValueOAuth(option, currentValue);
      }
    }
    option.value = currentValue;
    this.updateContent();
  }

  private SetValueMultiple(option, currentValue: any, currentFileName? : string) {
    let authenticator = this._authenticationContent.multipleMethod.authenticators.
      find(auth => auth.displayName === this._currentAuthenticator.displayName);
    if (authenticator) {
      let authenticatorCopy = JSON.parse(JSON.stringify(authenticator));
      if (authenticatorCopy.type === 'OAuth2' && authenticatorCopy.oauthOptions.flows) {
        let activeFlow = authenticatorCopy.oauthOptions.flows.find(flow => flow.name === authenticatorCopy.oauthOptions.activeFlow);
        if (activeFlow && activeFlow.properties) {
          let property = activeFlow.properties.find(property => property.name === option.name);
          property.value = currentValue;
        }
      }
      else if (authenticatorCopy.options && authenticatorCopy.options.hasOwnProperty(option.key)) {
        authenticatorCopy.options[option.key] = currentValue;
        if (option.key === 'encryptionCertificate') {
          authenticatorCopy.options['encryptionCertificateName'] = currentFileName ? currentFileName : '';
        }
        if (option.key === 'signatureCertificate') {
          authenticatorCopy.options['signatureCertificateName'] = currentFileName ? currentFileName : '';
        }
      }
      this._currentAuthenticator = authenticatorCopy;
    }
  }

  private updateContent() {
    const updatedAuthenticationContent = JSON.parse(JSON.stringify(this._authenticationContent));
    let index;
    if (this.selectedMethod.type === 'Mixed') {
      index = updatedAuthenticationContent.methods.findIndex(method => method.type === this.selectedMixedMethod.type);
      if (index !== -1) {
        updatedAuthenticationContent.methods[index] = this.selectedMixedMethod;
      }
    } else if (this.selectedMethod.type !== 'Multiple') {
      if (this.selectedMethod.subtype && this.selectedMethod.subtype.length > 0)
        index = updatedAuthenticationContent.methods.findIndex(method => method.type === this.selectedMethod.type && method.subtype === this.selectedMethod.subtype);
      else
        index = updatedAuthenticationContent.methods.findIndex(method => method.type === this.selectedMethod.type);
      if (index !== -1) {
        updatedAuthenticationContent.methods[index] = this.selectedMethod;
        if (this.selectedMethod.type === 'OAuth2') {
          updatedAuthenticationContent.activeFlow = (this.selectedMethod as IOAuth2AuthenticationMethod).oauthOptions.activeFlow;
        }
      }
    }
    this._authenticationContent = updatedAuthenticationContent;
    this.saveData();
  }

  private SetValue(option, currentValue, currentFileName? : string ) {
    const updatedSelectedMethod: IBasicAuthenticationMethod = {
      ...this.selectedMethod,
      options: {
        ...(this.selectedMethod as IBasicAuthenticationMethod).options,
        [(option as any).key]: currentValue
      }
    };
    if (option.key === 'encryptionCertificate') {
      updatedSelectedMethod.options.encryptionCertificateName = currentFileName ? currentFileName : '';
    }
    if (option.key === 'signatureCertificate') {
      updatedSelectedMethod.options.signatureCertificateName = currentFileName ? currentFileName : '';
    }
    this.selectedMethod = updatedSelectedMethod;
  }

  private SetValueOAuth(option, currentValue: any) {
    let selectedMethod = { ...this.selectedMethod } as IOAuth2AuthenticationMethod;
    const currentActiveFlow = selectedMethod.oauthOptions.activeFlow;
    const updatedSelectedMethod = {
      ...selectedMethod,
      oauthOptions: {
        ...selectedMethod.oauthOptions,
        flows: selectedMethod.oauthOptions.flows.map((flow) => {
          // Solo actualizar el flow activo
          if (flow.name === currentActiveFlow) {
            return {
              ...flow,
              properties: flow.properties.map((element: { name: string, value: any }) => {
                if (element.name === (option as IOAuthOptionsFlowProperty).name) {
                  return { ...element, value: currentValue };
                }
                return element;
              })
            };
          }
          // Mantener los otros flows sin cambios
          return flow;
        })
      }
    };
    this.selectedMethod = updatedSelectedMethod;
  }

  private SetValueMixed(option, currentValue) {
    const updatedSelectedMethod: IBasicAuthenticationMethod = {
      ...this.selectedMixedMethod,
      options: {
        ...(this.selectedMixedMethod as IBasicAuthenticationMethod).options,
        [(option as any).key]: currentValue
      }
    };
    this.selectedMixedMethod = updatedSelectedMethod;
  }

  private saveData() {
    const content = _.cloneDeep(this._authenticationContent as any);
    content.methods = JSON.stringify(content.methods);
    const dataContentString: any = this._authenticationContent;
    const updatedCatalogObjectResponseArray = [
      {
        ...this._catalogObjectResponse[0],
        content: dataContentString
      },
      ...this._catalogObjectResponse.slice(1)
    ];
    this._catalogObjectResponse = updatedCatalogObjectResponseArray;
    if (
      this._catalogObjectResponse[0].content.multipleMethod &&
      !!this._currentAuthenticator
    ) {
      let authenticators: Array<MultipleAuthenticator> = _.cloneDeep(this._catalogObjectResponse[0].content.multipleMethod.authenticators);
      let indexAuthenticatorModified = -1;
      indexAuthenticatorModified = authenticators.findIndex(auth => {
        return this._currentAuthenticator.displayName === auth.displayName;
      });

      if (indexAuthenticatorModified > -1) {
        authenticators[indexAuthenticatorModified] = this._currentAuthenticator;
      }
      this._catalogObjectResponse[0].content.multipleMethod.authenticators = authenticators;
    }
    if (!this.isSaving)
      this.putAuth();
  }

  public putAuth() {
    this.isSaving = true;
    const catalogObjectResponse = { ...this._catalogObjectResponse };
    if (!('activeSubtype' in catalogObjectResponse[0].content) || !catalogObjectResponse[0].content.activeSubtype) {
      catalogObjectResponse[0].content.activeSubtype = (this.selectedMethod as IBasicAuthenticationMethod).subtype || '';
    }
    const catalogObjectResponseArray = [catalogObjectResponse[0]];
    this._authenticationService
      .putAuthentication(catalogObjectResponseArray)
      .subscribe(response => {
        this.isSaving = false;
        this._store.dispatch(new GetAuthenticationData());
        this.loadingAuthentication = false;
        this.saveResponse$.next(true);
        this._store.dispatch(new GetAuthenticationIsValid());

        if (response.save) {
          this.typeInvalid = '';
          this.subtypeInvalid = '';
          this._showToastService.showToast(this._i18nService.instant('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY'), 'success');
          this._store.dispatch(new GetAuthenticationData());
          this._store.dispatch(new SetCurrentAuthenticator(this._currentAuthenticator));
        }

      },
        error => {
          this.loadingAuthentication = false;
        }
      );
  }

  public isMultipleAuthDetailValid() {
    return this._bzMultipleAuthDetail
      ? this._bzMultipleAuthDetail.isFormValid()
      : true;
  }

  public isDisabled(authenticator: MultipleAuthenticator): boolean {
    if (!authenticator || !authenticator.type) {
      return false;
    }
    if (authenticator.subtype) {
      return (
        this.metadata &&
        (!this.metadata[authenticator.type] ||
          !this.metadata[authenticator.type].options[authenticator.subtype])
      );
    } else {
      return this.metadata && !this.metadata[authenticator.type];
    }
  }

  getMessage() {
    let message = '';
    if (this.subtypeInvalid)
      message = this._translateService.instant('AUTHENTICATION.OPTION_INVALID_TYPE_SUBTYPE')
        .replace('{0}', this.typeInvalid)
        .replace('{1}', this.subtypeInvalid);
    else
      message = this._translateService.instant('AUTHENTICATION.OPTION_INVALID_TYPE_SUBTYPE')
        .replace('{0}', this.typeInvalid)
        .replace('-{1}', '');
    return message;
  }
}
